import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { PlusOutlined } from "@ant-design/icons";
import { List, Layout, Button, Row, Col, Input } from "antd";
import api from "../../Api";

const { Content } = Layout;
const { Search } = Input;

const CustomerPricesDataView = () => {
  const [customerPrices, setCustomerPrices] = useState([]);
  const [loading, setLoading] = useState(true);
  const [customers, setCustomers] = useState([]);
  useEffect(() => {
    const getCustomerPrices = async () => {
      const res = await api.customerPrices().get();
      const filteredArr = res.data.reduce((acc, current) => {
        const x = acc.find((item) => item.customerUid === current.customerUid);
        if (!x) {
          return acc.concat([current]);
        } else {
          return acc;
        }
      }, []);
      setCustomerPrices(filteredArr);
      setLoading(false);
    };
    const getCustomers = async () => {
      const { data } = await api.getCustomers().get();
      setCustomers(data);
    };
    getCustomers();
    getCustomerPrices();
  }, []);

  return (
    <Content style={{ margin: "24px 16px 0", overflow: "initial" }}>
      <Row type="flex" justify="space-between" align="middle">
        <Col span={6}>
          <h1>Customer prices</h1>
        </Col>
        <Col span={12}>
          <Search
            type="text"
            name="search"
            enterButton="Search"
            placeholder="input search text"
          />
        </Col>
        <Col span={6}>
          <div className="addNew">
            <Link to={{ pathname: `/cprice/?isNew=true` }}>
              <Button
                type="primary"
                icon={<PlusOutlined />}
                className="green-btn"
              >
                Add new
              </Button>
            </Link>
          </div>
        </Col>
      </Row>
      <div
        style={{
          padding: 24,
          background: "#fff",
          textAlign: "left",
          borderRadius: 12,
        }}
      >
        <List
          itemLayout="horizontal"
          loading={loading}
          pagination={{
            onChange: (page) => {
              console.log(page);
            },
            pageSize: 20,
          }}
          dataSource={customerPrices}
          renderItem={(customerPrice) => (
            <List.Item key={customerPrice.id}>
              <List.Item.Meta
                title={
                  customerPrice &&
                  customers &&
                  customers.some((x) => x.id === customerPrice.customerUid)
                    ? customers.find((x) => x.id === customerPrice.customerUid)
                        .businessName
                    : ""
                }
              />
              <Link
                to={{
                  pathname: `/cprice/?customer=${customerPrice.customerUid}&isNew=false`,
                }}
              >
                <Button>Show/Edit</Button>
              </Link>
            </List.Item>
          )}
        />
      </div>
    </Content>
  );
};

export default CustomerPricesDataView;
